import React from 'react';
import getValue from 'lodash.get';
import MCheckbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const CheckboxWithToggle = ({ name, requiredName, label, values, onChange, disabled }) => {
	const isVisible = !!getValue(values, name);
	const isRequired = !!getValue(values, requiredName);

	const handleVisible = (e) => {
		onChange({ target: { name, value: e.target.checked } });
		if (!e.target.checked) {
			onChange({ target: { name: requiredName, value: false } });
		}
	};

	const handleRequired = (e) => {
		onChange({ target: { name: requiredName, value: e.target.checked } });
	};

	return (
		<Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
			<FormControlLabel
				control={<MCheckbox checked={isVisible} onChange={handleVisible} disabled={disabled} />}
				label={null}
			/>
			{isVisible && (
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 'auto' }}>
					<Typography variant="body2">Required</Typography>
					<Switch
						checked={isRequired}
						onChange={handleRequired}
						disabled={disabled}
						size="small"
					/>
				</Box>
			)}
		</Box>
	);
};

CheckboxWithToggle.type = 'CheckboxWithToggle';

export default CheckboxWithToggle;
